export default __webpack_public_path__ + "static/media/17.400ec2b8.png";